export default {
	"ordersMultiple": {
		"lasterStartTime": "最晚开始时间",
		"lasterFinishTime": "最晚完成时间",
		"taskDetail": "任务明细",
		"actualPackingQty": "实际外包装数",
		"warningTimes": "预警数量",
		"completeBackDt": "回单完成时间",
		"finishLocationQty": "完成地点数",
		"finishTransportQty": "完成任务数",
		"processInformation": "过程信息",
		"BillingStatus": "计费状态",
		"settlementTime": "结算时间",
		"reckoner": "结算人",
		"payor": "结款人"
	},
	"ordersSingle": {
		"transportStop": "运输终止",
		"changeTransport": "改运",
		"demandInfo": "需求信息",
		"receiving": "收货",
		"taskExecutPreview": "任务执行一览",
		"executeInfo": "执行信息",
		"signName": "签收人",
		"backRemarks": "回单备注",
		"commonbackCheckedStatus": "回单状态"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/orders/orders.js